import { Component, OnInit, OnDestroy, Input, Output, NgZone, EventEmitter, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
// ngrx store
import { Subscription } from 'rxjs';
// import 'rxjs/add/operator/catch';
import { catchError } from 'rxjs/operators';

// models
import { AllowedTerminals } from '../../../models/airport-allowed-terminals.interface';
import { CollectionLocation } from '../../../models/collection.interface';
// service
import { EventsService } from '../../../services/events.service';
import { ImageByIdService } from '../../../../shared/services/image-by-id.service';

@Component({
  selector: 'app-airport',
  templateUrl: './airport.component.html',
  styleUrls: ['./airport.component.scss'],
  providers: [ImageByIdService]
})
export class AirportComponent implements OnInit, OnDestroy {

  @Input()
  airportData;

  @Input()
  bookingState;

  @Input()
  appCopy;

  @Input()
  selectedLanguage;

  @Input()
  currentBooking;

  @Output()
  handleShowMenu: EventEmitter<any> = new EventEmitter();

  @Output()
  sendToBooking: EventEmitter<any> = new EventEmitter();

  public flightDirection;
  public airportLocation: any = { airport: '', terminal: '' };
  public showTerminalDropDown = 'false';
  public airportSelected = false;
  public terminalSelected = false;
  public airportSelectedData: AllowedTerminals = {
    airport: '',
    airportCode: '',
    airportDropDownDisplayText: '',
    showTerminalDropDown: '',
    terminals: []
  };
  public terminalSelectedData;
  public locationData: CollectionLocation = {
    type: null,
    name: '',
    shortName: '',
    geoCoord: null,
    addressLine1: '',
    addressTown: '',
    addressPostCode: '',
    addressCountry: ''
  };
  public airportDisplay = '';
  public terminalImg: String;
  public terminalCopy;
  public isLoading = false;
  public showNoAirportError = false;
  public showNoTerminalError = false;
  public imgLoaded = false;
  public imgFail = false;
  public selectedAirportItem;
  public selectedTerminalItem;
  public setLocationName = '';

  private _imageUrlSubscription: Subscription;

  constructor(
    private _imageByIdService: ImageByIdService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    this.setDataSubscriptions();
  }

  setDataSubscriptions() {
    // used to get data from store
    this.setCurrentStoreVars();
    this.setCurrentBookingData();

    this._imageUrlSubscription = this._imageByIdService.imageUrlSubject$
      .subscribe(res => {

        if (res === 'error') {
          this.imgLoaded = true;
          this.imgFail = true;
          return;
        }

        this.terminalImg = res;
        this.imgFail = false;
        this.imgLoaded = true;
      });
  }
  // set booking state to vars
  setCurrentStoreVars() {
    this.flightDirection = this.bookingState.bookingDetails.journeyLegDetails[0].journeyDirection;
  }

  setCurrentBookingData() {

    if (
      this.currentBooking.bookingCompletion.collectionLocationDetails &&
      this.currentBooking.bookingJourney[0].collectionLocation.type === 8 &&
      this.flightDirection === 1
    ) {

      this.setLocationName = this.currentBooking.bookingJourney[0].collectionLocation.name;

      for (let i = 0; i < this.airportData.allowedTerminals.length; i++) {
        if (this.airportData.allowedTerminals[i].airport === this.setLocationName) {
          this.airportChanged(i, true);
          break;
        }
      }
    } else if (
      this.currentBooking.bookingCompletion.deliveryLocationDetail &&
      this.currentBooking.bookingJourney[0].deliveryLocation.type === 8 &&
      this.flightDirection === 2
    ) {

      this.setLocationName = this.currentBooking.bookingJourney[0].deliveryLocation.name;

      for (let i = 0; i < this.airportData.allowedTerminals.length; i++) {
        if (this.airportData.allowedTerminals[i].airport === this.setLocationName) {
          this.airportChanged(i, true);
          break;
        }
      }
    }
  }

  airportChanged(e, savedData?) {

    this.selectedAirportItem = e;

    this.airportSelectedData = this.airportData.allowedTerminals[e];
    this.airportLocation.airport = this.airportSelectedData.airport;
    this.showTerminalDropDown = this.airportSelectedData.showTerminalDropDown;

    this.airportSelected = true;
    this.terminalSelected = false;
    this.selectedTerminalItem = undefined;
    this.showNoAirportError = false;
    this.imgLoaded = false;
    this.airportLocation.terminal = '';


    if (savedData) {
      this.checkForSavedTerminalDetails();
    } else {
      if (this.showTerminalDropDown === 'false') {
        this.terminalChanged(0);
      }
    }
  }

  checkForSavedTerminalDetails() {

    if (
      this.currentBooking.bookingCompletion.collectionLocationDetails &&
      this.currentBooking.bookingJourney[0].collectionLocation.type === 8 &&
      this.flightDirection === 1
    ) {
      for (let i = 0; i < this.airportSelectedData.terminals.length; i++) {
        if (
          this.airportSelectedData.terminals[i].locationId.toLocaleLowerCase() ===
          this.currentBooking.bookingJourney[0].collectionLocation.locationId.toLocaleLowerCase()) {
          this.terminalChanged(i);
        }
      }
    } else if (
      this.currentBooking.bookingCompletion.deliveryLocationDetail &&
      this.currentBooking.bookingJourney[0].deliveryLocation.type === 8 &&
      this.flightDirection === 2
    ) {
      for (let i = 0; i < this.airportSelectedData.terminals.length; i++) {
        if (
          this.airportSelectedData.terminals[i].locationId.toLocaleLowerCase() ===
          this.currentBooking.bookingJourney[0].deliveryLocation.locationId.toLocaleLowerCase()) {
          this.terminalChanged(i);
        }
      }
    } else {
      return;
    }

  }

  terminalChanged(e) {

    this.selectedTerminalItem = e;
    this.terminalSelectedData = this.airportSelectedData.terminals[e];

    this.terminalCopy = this.airportSelectedData.terminals[e].terminalCopyText[this.flightDirection - 1].text;
    this.terminalSelected = true;
    this.showNoTerminalError = false;

    const reguestImg = {
      imageId: this.airportSelectedData.terminals[e].terminalImageId,
      width: 0,
      height: 0
    };
    this._imageByIdService.getImageUrl(reguestImg);
    this.handleShowMenu.emit(false);
  }

  clearInput() {
    this.airportSelected = false;
    this.terminalSelected = false;
    this.showTerminalDropDown = 'false';
    this.selectedAirportItem = '';
    this.selectedTerminalItem = '';
    this.handleShowMenu.emit(true);
  }

  handleSubmitLocation(value, isValid, e: Event) {
    e.preventDefault();

    if (isValid) {
      this.isLoading = true;
      const selectedAirportLocation = this.filterAirportLocation();
      this.sendToBooking.emit(selectedAirportLocation);
    } else {
      if (!value.airport) {
        this.showNoAirportError = true;
      } else if (!value.terminal) {
        this.showNoTerminalError = true;
      }
      if (isPlatformBrowser(this.platformId)) {
        document.body.scrollTop = 0;
      }
    }
  }

  filterAirportLocation() {
    let selected;
    for (const location of this.airportData.locations) {
      if (location.locationId.toLocaleLowerCase() === this.terminalSelectedData.locationId.toLocaleLowerCase()) {
        selected = location;
        return selected;
      }
    }
    return selected;
  }

  ngOnDestroy() {
    this._imageUrlSubscription.unsubscribe();
  }

}
